import angular from 'angular';
import * as R from 'ramda';

export default function EditAssetTypeDialogController(
  $q,
  $rootScope,
  $scope,
  $timeout,

  ssDialogService,
  alerts,
  loaderService,
  riskDataService,
  assignTopRiskTypesDialog,
  assetDataService,
  editAssetTypeDialog,
  assetSharedModelService,
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleEditAssetTypeSubmit = _handleEditAssetTypeSubmit;
  vm.handleAssignTopRiskTypesClick = _handleAssignTopRiskTypesClick;
  vm.handleITAssetChange = _handleITAssetChange;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    vm.newAssetType = angular.copy(vm.assetType);
    if (vm.newAssetType.customerAssetTypeId === 0) {
      vm.newAssetType.isITAsset = true;
    }
    _filterDataUses();
    _initEventListeners();
  }

  function _initEventListeners() {
    $scope.$on('refreshTopRiskTypes', (event, opt) => {
      if (opt.assetType.customerAssetTypeId === vm.newAssetType.customerAssetTypeId) {
        vm.newAssetType.customerRiskTypes = vm.newAssetType.customerRiskTypes || [];
        vm.newAssetType.customerRiskTypes = opt.assetType.customerRiskTypes;
      }
      // if (opt.assetType.customerAssetTypeId === vm.newAssetType.customerAssetTypeId) {
      //   loaderService.showViewLoader = true;
      //   _getAssignedRisks().then(() => {
      //     loaderService.showViewLoader = false;
      //   });
      // }
    });

    $scope.$on('pra_risk-type-updated', (event, opt) => {
      if (vm.newAssetType.customerRiskTypes && vm.newAssetType.customerRiskTypes.length > 0) {
        // eslint-disable-next-line max-len
        const pos = vm.newAssetType.customerRiskTypes.findIndex(item => item.customerRiskTypeId === opt.riskType.customerRiskTypeId);
        if (pos === -1) return; // Can't find the item
        vm.newAssetType.customerRiskTypes[pos] = opt.riskType;
      }
    });
    //   const topRiskTypeIds = vm.assetType.customerRiskTypes.map(riskType => riskType.customerRiskTypeId);
    //   if (topRiskTypeIds.includes(opt.riskType.customerRiskTypeId)) {
    //     loaderService.showViewLoader = true;
    //     _getAssignedRisks().then(() => {
    //       loaderService.showViewLoader = false;
    //     });
    //   }
    // });

    $scope.$on('pra_risk-type-deleted', (event, payload) => {
      if (payload.assetType.customerAssetTypeId === vm.newAssetType.customerAssetTypeId) {
        if (vm.newAssetType.customerRiskTypes && vm.newAssetType.customerRiskTypes.length > 0) {
          vm.newAssetType.customerRiskTypes = vm.newAssetType.customerRiskTypes.filter(
            riskType => riskType.customerRiskTypeId !== payload.riskType.customerRiskTypeId
          );
        }
      }
    });
  }

  function _handleCloseDialogClick() {
    // $rootScope.$broadcast('refreshRisks');
    ssDialogService.hide(ssDialogService.dialogs.assetAdmin.editAssetTypeDialog);
  }

  function _handleEditAssetTypeSubmit() {
    if ($scope.editAssetTypeForm.$valid) {
      loaderService.showViewLoader = true;
      _saveAssetType().then(() => {
        _closeDialog().then(() => {
          loaderService.showViewLoader = false;
          if (vm.saveType === 'saveAndAddAnother') {
            $timeout(
              () => {
                _showEditAssetTypeDialog(undefined);
              },
              0
            );
          }
        });
      });
    }
  }

  function _handleAssignTopRiskTypesClick($event) {
    vm.assignTopRisksClicked = true;
    if ($scope.editAssetTypeForm.$valid) {
      loaderService.showViewLoader = true;
      const promises = [
        riskDataService.getRiskTypes(),
        _saveAssetType(),
      ];
      return $q.all(promises).then((results) => {
        let riskTypes = results[0].data.result;
        const assignedRiskTypeIds = vm.newAssetType.customerRiskTypes.map(
          customerAssetRiskType => customerAssetRiskType.customerRiskTypeId
        );
        if (assignedRiskTypeIds && assignedRiskTypeIds.length > 0) {
          riskTypes = riskTypes.map((riskType) => {
            if (assignedRiskTypeIds.includes(riskType.customerRiskTypeId)) {
              riskType.isAssigned = true;
            } else {
              riskType.isAssigned = false;
            }
            return riskType;
          });
        }
        ssDialogService.dialogs.assetAdmin.assignTopRiskTypesDialog = ssDialogService.alert(
          assignTopRiskTypesDialog.getOptions($event, {
            assetType: vm.newAssetType,
            riskTypes,
          })
        );
        loaderService.showViewLoader = false;
        ssDialogService.show(ssDialogService.dialogs.assetAdmin.assignTopRiskTypesDialog);
      });
    }
    return false;
  }

  function _handleITAssetChange() {
    _filterDataUses();
  }

  function _saveAssetType() {
    const isNew = vm.newAssetType.customerAssetTypeId <= 0;
    if (!isNew && angular.equals(vm.assetType, vm.newAssetType)) {
      return Promise.resolve();
    }
    vm.newAssetType.assetDataTypeId = vm.newAssetType.assetDataType.assetDataTypeId;
    vm.newAssetType.assetCriticalityId = vm.newAssetType.assetCriticality.assetCriticalityId;
    vm.newAssetType.assetDataUseId = vm.newAssetType.assetDataUse.assetDataUseId;
    vm.newAssetType.customerRiskTypes = vm.newAssetType.customerRiskTypes || [];

    return assetDataService.saveAssetType(vm.newAssetType).then((response) => {
      if (!response.data) {
        alerts.error('An error occurred while saving the Asset Type.');
      } else {
        alerts.success('The Asset Type has been saved successfully.');
        _initCriticality(vm.newAssetType);
        if (isNew === true) {
          vm.newAssetType.customerAssetTypeId = response.data.customerAssetTypeId;
          $rootScope.$broadcast('refreshAssetTypes');
        } else {
          vm.newAssetType = {
            ...vm.assetType,
            ...response.data,
          };
          $rootScope.$broadcast('refreshAssetTypeSync', { assetType: vm.newAssetType });
          $rootScope.$broadcast('refreshAssetType', { assetType: vm.newAssetType });
          $rootScope.$broadcast('refreshAssets', { assetType: response.data });
        }

        vm.assetType = angular.copy(vm.newAssetType);
      }
    });
  }

  // function _getAssignedRisks() {
  //   return assetDataService.getAssetType(vm.assetType.customerAssetTypeId).then((response) => {
  //     if (response.data) {
  //       vm.newAssetType = response.data;
  //       vm.newAssetType.customerRiskTypes = assetSharedModelService.addSeverityDescriptionsToRisks(
  //         vm.newAssetType.customerRiskTypes
  //       );
  //       vm.assetType = angular.copy(vm.newAssetType);
  //     }
  //   });
  // }

  function _showEditAssetTypeDialog($event) {
    const _assetType = { customerAssetTypeId: 0 };
    assetDataService.getAssetTypeDefaults().then((response) => {
      _assetType.assetDataType = response.data.assetDataType;
      _assetType.assetCriticality = response.data.assetCriticality;
      _assetType.assetDataUse = response.data.assetDataUse;

      ssDialogService.dialogs.assetAdmin.editAssetTypeDialog = ssDialogService.alert(
        editAssetTypeDialog.getOptions($event, {
          assetType: _assetType,
          assetCriticalities: assetSharedModelService.AssetCriticalities,
          assetDataTypes: assetSharedModelService.AssetDataTypes,
          assetDataUses: assetSharedModelService.AssetDataUses,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.assetAdmin.editAssetTypeDialog);
    });
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.assetAdmin.editAssetTypeDialog);
  }

  function _filterDataUses() {
    const isITAsset = vm.newAssetType.isITAsset;
    const assetType = isITAsset ? 1 : 2;
    const doesStoreNPI = vm.newAssetType.assetDataUse.assetDataUseId === 2
      || vm.newAssetType.assetDataUse.assetDataUseId === 4;
    vm.filteredAssetDataUses = R.filter(
      R.propEq('AssetType', assetType),
      vm.assetDataUses
    );
    if (isITAsset) {
      vm.newAssetType.assetDataUseId = doesStoreNPI ? 2 : 1;
    } else {
      vm.newAssetType.assetDataUseId = doesStoreNPI ? 4 : 3;
    }
    vm.newAssetType.assetDataUse = vm.assetDataUses.find(
      assetDataUse => assetDataUse.assetDataUseId === vm.newAssetType.assetDataUseId
    );
  }

  function _initCriticality(assetType) {
    if (assetType.assetCriticalityId) {
      const classMappings = {
        1: 'status-tier-bar--terrible',
        2: 'status-tier-bar--bad',
        3: 'status-tier-bar--caution',
        4: 'status-tier-bar--good',
        5: 'status-tier-bar--great',
      };
      assetType.criticalityCssClass = classMappings[assetType.assetCriticalityId];
      if (!assetType.assetCriticality) {
        assetType.assetCriticality = assetSharedModelService.AssetCriticalities.find(
          assetCriticality => assetCriticality.assetCriticalityId === assetType.assetCriticalityId
        );
      }
    }
  }
}

EditAssetTypeDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  '$timeout',

  'ssDialogService',
  'alerts',
  'loaderService',
  'riskDataService',
  'assignTopRiskTypesDialog',
  'assetDataService',
  'editAssetTypeDialog',
  'assetSharedModelService'
];
